import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import pageBackground from "../asset/image/img25.png";

function PurchaseForm() {
  const [formData, setFormData] = useState({
    name: "",
    persons: "",
    days: "1",
    bookingDate: "",
    country: "",
    mobileNumber: "",
  });

  const navigate = useNavigate();

  const countries = [
    "United States",
    "United Kingdom",
    "Canada",
    "Australia",
    "Germany",
    "France",
    "Japan",
    "India",
    "China",
    "Brazil",
    "Other",
  ];

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create email content
    const emailContent = `
      Name: ${formData.name}
      Number of Persons: ${formData.persons}
      Days: ${formData.days}
      Booking Date: ${formData.bookingDate}
      Country: ${formData.country}
      Mobile Number: ${formData.mobileNumber}
    `;

    // Create WhatsApp message
    const whatsappMessage = encodeURIComponent(emailContent);
    const whatsappNumber = "+94702027631"; // Replace with your WhatsApp number
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

    // Create mailto link
    const emailSubject = "New Booking Request";
    const emailTo = "yasassrie@gmail.com"; // Replace with your email
    const mailtoLink = `mailto:${emailTo}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailContent)}`;

    // Open both in new tabs
    window.open(mailtoLink, "_blank");
    window.open(whatsappUrl, "_blank");
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const styles = {
    container: {
      width: "100%",
      minHeight: "100vh",
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${pageBackground})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundAttachment: "fixed",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px",
    },
    formCard: {
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      borderRadius: "15px",
      padding: "40px",
      width: "100%",
      maxWidth: "500px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      marginTop: "120px",
      position: "relative",
    },
    closeButton: {
      position: "absolute",
      top: "20px",
      right: "20px",
      backgroundColor: "transparent",
      border: "none",
      color: "#202020",
      fontSize: "24px",
      cursor: "pointer",
    },
    title: {
      textAlign: "center",
      color: "#333",
      marginBottom: "30px",
      fontSize: "24px",
      fontWeight: "bold",
    },
    formGroup: {
      marginBottom: "20px",
    },
    label: {
      display: "block",
      marginBottom: "8px",
      color: "#333",
      fontSize: "16px",
    },
    input: {
      width: "100%",
      padding: "12px",
      borderRadius: "8px",
      border: "1px solid #ddd",
      fontSize: "16px",
    },
    select: {
      width: "100%",
      padding: "12px",
      borderRadius: "8px",
      border: "1px solid #ddd",
      fontSize: "16px",
      backgroundColor: "white",
    },
    submitButton: {
      width: "100%",
      padding: "14px",
      backgroundColor: "#007AFF",
      color: "white",
      border: "none",
      borderRadius: "8px",
      fontSize: "16px",
      cursor: "pointer",
      transition: "background-color 0.3s",
    },
  };

  const handleCardClose = () => {
    navigate("/packages");
  };

  return (
    <div style={styles.container}>
      <div style={styles.formCard}>
        <h2 style={styles.title}>Complete Your Booking</h2>
        <button style={styles.closeButton} onClick={handleCardClose}>
          ×
        </button>

        <form onSubmit={handleSubmit}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              style={styles.input}
              placeholder="Enter your name"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>
              Mobile Number(Enter your mobile number wiith country code)
            </label>
            <input
              type="tel"
              name="mobileNumber"
              value={formData.mobileNumber}
              onChange={handleChange}
              required
              style={styles.input}
              placeholder="Enter your mobile number"
              pattern="[0-9+\-\s]+"
              title="Please enter a valid phone number"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Number of Persons</label>
            <input
              type="number"
              name="persons"
              value={formData.persons}
              onChange={handleChange}
              required
              min="1"
              style={styles.input}
              placeholder="Enter number of persons"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Number of Days</label>
            <select
              name="days"
              value={formData.days}
              onChange={handleChange}
              style={styles.select}
            >
              {[...Array(10)].map((_, i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1} Day{i !== 0 ? "s" : ""}
                </option>
              ))}
            </select>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Booking Date</label>
            <input
              type="date"
              name="bookingDate"
              value={formData.bookingDate}
              onChange={handleChange}
              required
              style={styles.input}
              min={new Date().toISOString().split("T")[0]}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Country</label>
            <select
              name="country"
              value={formData.country}
              onChange={handleChange}
              required
              style={styles.select}
            >
              <option value="">Select a country</option>
              {countries.map((country) => (
                <option key={country} value={country}>
                  {country}
                </option>
              ))}
            </select>
          </div>

          <button type="submit" style={styles.submitButton}>
            Submit Booking
          </button>
        </form>
      </div>
    </div>
  );
}

export default PurchaseForm;

